/*
 * @Author: fengxiaojing
 * @LastEditTime: 2022-09-08 13:12:06
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  Document: '文档',
  parseFileNameAddDocument: '解析文件名创建文档',
  SearchForDocumentNameOrEncoding: '搜索文档名称或者编码',
  RecursiveDisplay: '递归显示',
  AdvancedSearch: '高级搜索',
  transfer: '移交',
  uploadFiles: '上传文件',
  DownloadTheFileAssociatedWithTheDocument: '下载文档所关联的文件',
  directoryTree: '目录树',
  documentEncoding: '文档编码',
  documentName: '文档名称',
  documentCategory: '文档类别',
  Version: '版本',
  state: '状态',
  creationTime: '创建时间',
  createUser: '创建用户',
  LastModified: '最后修改时间',
  LastModifiedUser: '最后修改用户',
  ScheduledDeliveryTime: '计划交付时间',
  ActualDeliveryTime: '实际交付时间',
  BrowseDocumentObjects: '浏览文档对象',
  upgrade: '升版',
  historicVersion: '历史版本',
  addFolder: '新增文件夹',
  FolderName: '文件夹名称',
  BulkAddFolders: '系统支持批量添加文件夹，每一行为一个文件夹',
  editFolder: '编辑文件夹',
  FolderPath: '文件夹路径',
  editDocument: '编辑文档',
  BasicProperties: '基本属性',
  coding: '编码',
  path: '路径',
  category: '类别',
  TemplateProperties: '模板属性',
  connectionRelation: '关联关系',
  updateAll: '更新全部',
  updateSelected: '更新选中',
  setDefaultFile: '设置默认文件',
  fileName: '文件名称',
  defaultFile: '默认文件',
  enterTitle: '输入标题',
  addAssociation: '添加关联关系',
  WhetherToDisassociate: '是否解除关联关系',
  objectName: '对象名称',
  Disassociate: '解除关联关系',
  AssociatedDocuments: '关联文档',
  AddAssociatedDocuments: '添加关联文档',
  enterATagCodeOrName: '请输入位号代码或名称',
  enterAnAlias: '请输入别名',
  AddDocument: '新增文档',
  DownloadProgress: '下载进度',
  HistoryUpgrade: '历史升版',
  DocumentationUpgrade: '文档升级',
  Uploader: '上传人',
  UploadTime: '上传时间',
  documentStatus: '文档状态',
  DownloadDistoricalVersionFiles: '下载历史版本文件',
  documentHandover: '文档移交',
  ProcessApproval: '流程审批',
  ProcessType: '流程类型',
  ProcessStatus: '流程状态',
  Reviewer: '审核人',
  DocumentationDirectory: '文档目录',
  deadline: '截止时间',
  handoverDocuments: '实体文档',
  ManualAssociation: '手动关联',
  uploadFiles: '上传文件',
  fileUploadProcessing: '文件上传处理中',
  PleaseSelectACategory: '请选择类别',
  NotHandedOver: '未移交',
  underReview: '审核中',
  handedOver: '已移交',
  PleaseEnterCode: '请输入编码',
  PleaseEnterAName: '请输入名称',
  PleaseSelectAPath: '请选择路径',
  PleaseEnterVersion: '请输入版本',
  LengthCannotExceedTenCharacters: '长度不能超过10个字符',
  PleaseFnterAFolderName: '请输入文件夹名称',
  PleaseEnterTheFolderPath: '请输入文件夹路径',
  PleaseEnterATitle: '请输入标题',
  PleaseSelectAProcessType: '请选择流程类型',
  PleaseSelectADocumentDirectory: '请选择文档目录',
  PleaseSelectATime: '请选择时间',
  fileCode: '文件代码',
  PleaseSelectAnAssociatedFile: '请选择关联文件',
  TheAssociatedFileIsSuccessful: '关联文件成功',
  PleaseSelectADocumentToLink: '请选择要关联的文档',
  DisassociationSucceeded: '解除关联关系成功',
  UploadedSuccessfully: '上传成功',
  SecondPassIsSuccessful: '秒传成功',
  TheTreeVodeNameCannotBeTheSamepleaseRe_enter: '树节点名称不能相同,请重新输入',
  AreYouSureYouWantToDeleteTheCorrespondingDirectory: '您确定要删除对应的目录',

  DeleteDirectoriesAndDirectories:
    '该目录下包含有文档，如果强行删除，会将该目录下的文档删除，是否确定要删除所选择的目录',
  addedSuccessfully: '新增成功',
  successfullyDeleted: '删除成功',
  SuccessfullyModified: '修改成功',
  WhetherToDeleteTheCheckedData: '是否删除已勾选中的数据',
  WhetherToDelete_filteredData: '是否删除(已自动过滤审核中和已移交的数据)',
  PleaseTickTheDeletedItem: '请勾选删除的项',
  RequiredFieldsAreNotFilled: '必填项未填',
  PleaseCheckTheFileAndThenSetTheDefaultFile: '请勾选文件后再设置默认文件',
  OnlyOneDefaultFileCanBeSet: '默认文件只能设置一个',
  SetDefaultFileSuccessfully: '设置默认文件成功',
  PleaseClickTheFileListOnTheLeft: '请点击左边文件列表',
  PleaseConfirmIfYouWantToContinue: '请确认是否要继续',
  SuccessfulOperation: '操作成功',
  NoRecordsAreCurrentlySelected: '当前没有选中任何记录',
  PleaseSelectAnObjectNotHandedOver: '请选择未移交的对象',
  DocumentDataUnderReviewAndHandedOverHasBeenAutomaticallyFiltered:
    '已自动过滤审核中和已移交的文档数据',
  DocumentHandoverProcess: '文档移交流程',
  at: '于',
  InitiateProcess: '发起流程',
  DocumentPublishingProcess: '文档发布流程',
  ReviewerCannotBeEmpty: '审核人不能为空',
  ruleExpression: '规则表达式：',
  enterRuleExpression:
    "大括号括起来的文档属性及单引号中的连接符，如：{code}'拼接规则'{name}'拼接规则'{Revision}",
  enterRightRuleExpression: '请输入正确的规则表达式',
  compareVersions: '版本比较',
  checkIn: '检入',
  checkOut: '检出',
}
